/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedMeasurementUnitProvider_user$ref = any;
type SbSharedRefineMenuDimensionUnitRadioSelect_user$ref = any;
export type SbSharedRefineMenuInputRangeDimensions_user$ref = any;
export type SbSharedRefineMenuInputRangeDimensions_user = {
    readonly " $fragmentRefs": SbSharedMeasurementUnitProvider_user$ref & SbSharedRefineMenuDimensionUnitRadioSelect_user$ref;
    readonly " $refType": SbSharedRefineMenuInputRangeDimensions_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuInputRangeDimensions_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedMeasurementUnitProvider_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuDimensionUnitRadioSelect_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'c857af47a8a37f29367946d18603b847';
export default node;
